import type { Facet, FacetOption } from 'src/redux/productsQuery/types/Facet';
import type { TaxonomyAttribute } from 'src/redux/productsQuery/types/ProductsQueryState';

/**
 * The options the taxonomy navigation can offer at a given level: the active
 * one(s) plus any with a non-zero count. An empty result means the level has
 * nothing to navigate into, i.e. the current page is the deepest level of its
 * branch.
 */
export const getTaxonomyNavLevelOptions = (
  facets: Facet[],
  taxonomyAttributeAliases: TaxonomyAttribute[],
  levelIndex: number,
): FacetOption[] => {
  const alias = taxonomyAttributeAliases[levelIndex];

  return (
    facets
      .find((facet) => facet.alias === alias)
      ?.options.filter((option) => option.active || option.count !== 0) ?? []
  );
};
